// Homepage content and configuration
export interface HeroHomeButton {
  text: string;
  variant: "primary" | "secondary";
  route: string;
  onClick?: () => void;
}

/** Slide config: string URL or { src, duration } for images (duration in seconds) */
export type HeroSlide = string | { src: string; duration?: number };

export interface HeroHome {
  hero: {
    title: string;
    description: string;
    /** Slides: video URLs or { src, duration } for images. Videos auto-transition on end. */
    backgroundVideos: HeroSlide[];
    fallbackImage?: string;
    buttons: HeroHomeButton[];
    additionalButtons?: HeroHomeButton[];
  };
}

export const HeroHomeConstants: HeroHome = {
  hero: {
    title: `CricCenter
One Cricket Ecosystem`,
    description: `The complete digital ecosystem for scoring, streaming, AI video analysis, AI highlights, AI analytics, and more.`,
    backgroundVideos: [
      { src: "/videos/BCA.mp4", duration: 10 },
      { src: "/videos/CRED.mp4", duration: 10 },
      { src: "/videos/guj.mkv", duration: 10 },
      // { src: "/videos/defense_1.gif", duration: 10 },
    ],
    fallbackImage: "", // Path to GIF/image when no videos
    buttons: [
      {
        text: "Get Started",
        variant: "primary",
        route: "/leagues-home",
      },
      // {
      //   text: "Learn More",
      //   variant: "secondary",
      //   route: "/pricing",
      // },
    ],
  },
};
